import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ErrorKind } from '@/utils/apiError'

interface AppError {
  id: string
  message: string
  kind: ErrorKind
  technical?: string
}

export const useErrorStore = defineStore('errors', () => {
  const errors = ref<AppError[]>([])
  let counter = 0

  function add(message: string, kind: ErrorKind = 'user', technical?: string): string {
    const id = String(++counter)
    errors.value = [...errors.value, { id, message, kind, technical }]
    return id
  }

  function dismiss(id: string): void {
    errors.value = errors.value.filter((e) => e.id !== id)
  }

  return { errors, add, dismiss }
})
